import React, { useState } from "react";
import useApi from "hooks/useApi";
import useApp from "hooks/useApp";
import ListGroupsToSelect from "./ListGroupsToSelect";
import GruposGestorEditPage from "./Edit";
import GruposGestorAddPage from "./Add";

export default class GridMethods extends React.Component {

    constructor(props) {
        super(props);
        this.api = useApi();
        this.app = useApp();
        this.state = {
            GroupList: [],
        };
    }

    /// Método para carregar a lista de grupos
    fetchDataGrupsList = async (onSuccess, onError) => {
        try {
            const response = await this.api.get("GrupoGestor/list");
            if (onSuccess) onSuccess(response.data); // Chama o callback de sucesso
            return response.data;
        } catch (error) {
            if (onError) onError(error); // Chama o callback de erro            
            return [];
        }
    };

    /// Método para carregar a lista de produtos
    fetchProdutosAsync = async (onSuccess, onError) => {
        try {
            const response = await this.api.get(`produtos?search=`);
            if (onSuccess) onSuccess(response.data); // Chama o callback de sucesso
            return response.data.records;
        } catch (error) {
            console.error("Erro ao buscar produtos:", error);
            if (onError) onError(error); // Chama o callback de erro
            return [];
        }
    };

    /// Método para carregar a lista de produtos do grupo
    fetchGestorProductList = async (param, onSuccess, onError) => {
        try {
            const response = await this.api.get(`grupogestor/list/grid/${param}`);
            if (onSuccess) onSuccess(response.data); // Chama o callback de sucesso
            return response.data;
        } catch (error) {
            console.error("Erro ao buscar produtos:", error);
            if (onError) onError(error); // Chama o callback de erro
            return [];
        }
    };

    /// Método para salvar os produtos do grupo na Base
    OnRowEditSave = async (rowData) => {
        let postData = {
            grupoid: rowData.grupoid,
            prodid: rowData.prodid,
            qtde: rowData.qtde,
            periodic: rowData.periodic,
        };
        try {
            let response = await this.api.post("grupogestor/add/produto", postData);
            return response?.data;
        } catch (error) {
            console.error("Erro ao salvar:", error);
            throw error;
        }
    };

    /// Adiciona um produto ao grupo diretamente
    addProdutoAoGrupo = async (postData) => {
        try {
            const response = await this.api.post("grupogestor/add/produto", postData);
            this.app.flashMsg("Produto adicionado com sucesso!");
            return { success: true, data: response?.data };
        } catch (error) {
            console.error("Erro ao adicionar produto:", error);
            const msg = error?.response?.data?.xmessage || "Erro ao adicionar produto";
            this.app.flashMsg(msg);
            return { success: false, error };
        }
    };

    /// Adiciona uma nova linha inline (legado)
    OnClickAddNewRow = async (SelectedGroup, rowData, OnNewRowData) => {
        try {
            let maxId = Math.max(...rowData.map(item => item.id), 0);
            maxId++;
            const newProd = {
                id: maxId,
                grupoid: SelectedGroup,
                prodid: null,
                prodNome: "CLICK AO LADO PARA EDITAR ------------------------>",
                qtde: 1,
                periodic: 90,
            };
            const newRowData = rowData.concat(newProd);
            OnNewRowData(newRowData);
            return { success: true };
        } catch (error) {
            console.log("Erro ao adicionar nova linha:", error);
            return { success: false };
        }
    };

    /// Seleciona um grupo de produtos para importar em lote
    OnClickSelectProductGroup = (SelectedGroup, onHide) => {
        this.app.openPageDialog(<ListGroupsToSelect grupoid={SelectedGroup} />, {
            maximized: false,
            closeBtn: true,
            width: "55vw",
            onHide: () => {
                if (onHide) onHide();
            }
        });
    };

    OnClickEditGroup = async (SelectedGroup, onHide) => {
        this.app.openPageDialog(
            <GruposGestorEditPage
                apiPath={`/grupogestor/edit/${SelectedGroup}`}
            />,
            {
                maximized: false,
                closeBtn: true,
                width: "50vw",
                onHide: () => {
                    if (onHide) onHide();
                },
            }
        );
    };

    OnClickAddGroup = (onHide) => {
        this.app.openPageDialog(<GruposGestorAddPage />, {
            maximized: false,
            closeBtn: true,
            width: "50vw",
            onHide: () => {
                if (onHide) onHide();
            }
        });
    };

    OnClickExcludeSelection = async (row) => {
        const confirmed = await this.app.dialog.Confirm("Confirmação", "Tem certeza que deseja excluir os itens selecionados?");
        if (confirmed == true) {
            try {
                let rows = row.map((item) => item.id);
                let selectedGrupo = row[0].grupoid;
                let query = rows.map((item) => `prods=${item}`).join("&");
                await this.api.delete(`GrupoGestor?groupid=${selectedGrupo}&${query}`);
                this.app.flashMsg("Itens excluídos com sucesso!");
                return { success: true };
            } catch (error) {
                console.error("Erro ao excluir:", error);
                this.app.flashMsg("Erro ao excluir os itens selecionados!");
                return { success: false };
            }
        }
        return { success: false };
    };

    OnClickDeleteGroup = async (SelectedGroup) => {
        const confirmed = await this.app.dialog.Confirm("Confirmação", "Excluir o Grupo Selecionado?");
        if (confirmed) {
            try {
                const response = await this.api.delete(`grupogestor/delete/group/${SelectedGroup}`);
                if (response.data.success) {
                    this.app.flashMsg("Grupo excluído com sucesso!");
                    return { success: true };
                } else {
                    console.log("Erro ao excluir:", response.data.xmessage);
                    this.app.flashMsg(response.data.xmessage);
                    return { success: false };
                }
            } catch (error) {
                this.app.flashMsg("Erro ao excluir o grupo selecionado!");
                console.error("Erro ao excluir:", error);
                return { success: false };
            }
        }
        return { success: false };
    };

}
